/* jshint ignore:start */
if (typeof define !== 'function') {
    var define = require('amdefine')(module)
}
/* jshint ignore:end */

define('pdfGear/generator/zoning',['lodash', '../localization/labels', '../localization/messages'],
    function(_, labels, messages) {
        'use strict';

        var zoningWidgetTitleStyle = {
                fontSize: 16,
                margin: [0, 20, 0, 5]
            },
            zoningWidgetHeaderStyle = {
                fontSize: 9
            },
            zoningTableHeaderStyle = {
                fontSize: 9,
                fillColor: '#e5e5e5',
                margin: [0, 2, 0, 2],
                alignment: 'left',
            },
            zoningTableEvenRowStyle = {
                fontSize: 9,
                fillColor: '#ffffff',
                margin: [0, 2, 0, 2]
            },
            zoningTableOddRowStyle = {
                fontSize: 9,
                fillColor: '#f9f9f9',
                margin: [0, 2, 0, 2]
            },
            zoningErrorMsg = {
                fontSize: 10,
                margin: [0, 9, 0, 9],
                alignment: 'center',
                fillColor: '#f9f9f9'
            },
            zoningColumns = [{
                key: 'zoneName',
                alignment: 'left'
            }, {
                key: 'deviceName',
                alignment: 'left'
            }, {
                key: 'radius',
                alignment: 'right'
            }, {
                key: 'dwellTime',
                alignment: 'right'
            }, {
                key: 'footfall',
                alignment: 'right'
            }],
            /**
             * constant of intraday value for "All Day"
             * @type {String}
             */
            ALL_DAY = 'all';

        return {
            zoningWidgetTitleStyle: zoningWidgetTitleStyle,
            zoningWidgetHeaderStyle: zoningWidgetHeaderStyle,
            zoningTableHeaderStyle: zoningTableHeaderStyle,
            zoningTableOddRowStyle: zoningTableOddRowStyle,
            zoningTableEvenRowStyle: zoningTableEvenRowStyle,
            zoningErrorMsg: zoningErrorMsg,
            constructZoningWidget: constructZoningWidget,
            getPaletteImage: getPaletteImage,
        };

        /**
         * Function to construct zoning widget along with table
         * @param  data for zoning widget
         * @return array of javascript objects formatted according to pdfmake format
         */
        function constructZoningWidget(widget) {
            var partial;
            partial = [{
                text: widget.title,
                style: 'chartTitleStyle',
                margin: [0, 0, 0, 10]
            }, {
                table: {
                    widths: [100, '*', '*'],
                    body: [
                        [
                            addLocation(widget.location), {
                                alignment: 'right',
                                columns: [{
                                    text: (
                                        '(' + widget.duration + ' ' +
                                        labels.others.DAYS + ') ' +
                                        widget.customDuration
                                    ),
                                    alignment: 'right',
                                    style: 'zoningWidgetHeaderStyle',

                                }]
                            }, {
                                width: 'auto',
                                text: labels.zoning.intraDayText + widget.filterIntraDayTime.value,
                                alignment: 'right',
                                style: 'zoningWidgetHeaderStyle'
                            }
                        ]
                    ]
                },
                layout: 'noBorders',
            }, {
                table: {
                    widths: ['*'],
                    body: [
                        [{
                            width: 'auto',
                            text: widget.noLayout ? '' : (
                                labels.zoning.dimensions + widget.dimensions
                            ),
                            alignment: 'right',
                            style: 'zoningWidgetHeaderStyle'
                        }]
                    ]
                },
                layout: 'noBorders',
            }];

            // pushing the comple chart into the partial
            if (widget.floorImage && widget.floorImage.image) {
                partial.push.apply(partial, [{
                    table: {
                        headerRows: 0,
                        widths: [505],
                        body: [
                            [{
                                image: widget.floorImage.image,
                                width: 515,
                                margin: [-3, 0, 0, 0]

                            }]
                        ],
                    },
                    layout: {
                        hLineWidth: function() {
                            return 0;
                        },
                        vLineWidth: function() {
                            return 0;
                        },
                        hLineColor: function() {
                            return '#e5e5e5';
                        },
                        vLineColor: function() {
                            return '#e5e5e5';
                        }
                    },
                }, {
                    margin: [0, 5, 0, 0],
                    table: {
                        headerRows: 0,
                        widths: [160, '*'],
                        body: [
                            [{
                                text: labels.zoning.type + widget.selectedView,
                                fontSize: 11,
                                margin: [10, 15, 0, 0]
                            }, {
                                stack: [{
                                        text: widget.paletteText,
                                        fontSize: 8
                                    },
                                    getPaletteImage(widget.paletteColors, widget.bucketValues),
                                ]
                            }],
                        ]
                    },
                    layout: {
                        hLineWidth: function() {
                            return 1;
                        },
                        vLineWidth: function(i) {
                            return (i === 1 ? 0 : 1);
                        },
                        hLineColor: function() {
                            return '#e5e5e5';
                        },
                        vLineColor: function() {
                            return '#e5e5e5';
                        }
                    },
                }]);
            }

            if (widget.noLayout) {
                widget.errorMessage = widget.errorMessage || messages.zoning.noLayout;
            } else if (widget.tableData && widget.tableData.length) {
                partial.push(constructZoningTable(
                    widget.tableData,
                    widget.units,
                    widget.filterIntraDayTime.key
                ));
            } else {
                widget.errorMessage = widget.errorMessage || messages.zoning.noZones;
            }

            if (widget.errorMessage) {
                partial.push({
                    margin: [5, 5, 0, 0],
                    table: {
                        headerRows: 0,
                        widths: [510],
                        body: [
                            [{
                                text: widget.errorMessage,
                                style: 'zoningErrorMsg'
                            }]
                        ],
                    },
                    layout: 'noBorders',
                });
            } else {
                partial.push({
                    text: messages.zoning.deviceDataMismatch,
                    style: 'bulletMessageStyle'
                });
            }

            return partial;
        }

        /**
         * Function to add location (either location name or it's image) to zoning widget
         * @param location contains javascript object containing location data
         */
        function addLocation(location) {
            var partial = (location.image) ? {
                margin: [8, 0, 0, 0],
                image: location.image,
                alignment: 'left',
                width: location.width,
                height: location.height,
            } : {
                margin: [5, 0, 0, 0],
                text: location.value,
                alignment: 'left',
                style: 'zoningWidgetHeaderStyle'
            };
            return partial;
        }

        /**
         * function to construct table for zoning widgets. All tables in zoning follow same format.
         * @param  {Array} tableData    Array containing tabledata
         * @param  {[type]} units       Units for floor    
         * @return {Object}             Table-data
         */
        function constructZoningTable(tableData, units, intraday) {
            var partial;
            if (tableData.length) {
                var rowStyles = ['zoningTableEvenRowStyle', 'zoningTableOddRowStyle'],
                    //table should be encapsulated by another container (javascript object) according to the pdfmake format
                    zoningTableContainer = {
                        margin: [0, 10, 0, 0]
                    },
                    zoningTable = {
                        headerRows: 1,
                        widths: [150, '*', '*', '*', '*']
                    },
                    header = [
                        //header of the table
                        {
                            text: labels.zoning.zoneName,
                            style: 'zoningTableHeaderStyle'
                        }, {
                            text: labels.zoning.deviceName,
                            style: 'zoningTableHeaderStyle'
                        }, {
                            text: labels.zoning.radius.replace('{units}', units),
                            style: 'zoningTableHeaderStyle'
                        }, {
                            text: labels.zoning.dwellTime,
                            style: 'zoningTableHeaderStyle'
                        }, {
                            text: ALL_DAY === intraday ? (
                                labels.zoning.footfallPerDay
                            ) : (
                                labels.zoning.footfallPerHour
                            ),
                            style: 'zoningTableHeaderStyle'
                        }
                    ],
                    body = _.map(tableData, function(currentValue, index) {
                        return _.map(zoningColumns, function(map) {
                            var cell = {
                                text: currentValue[map.key],
                                style: rowStyles[index % 2],
                                alignment: map.alignment
                            };

                            // in case zone is deleted
                            if ('zoneName' === map.key && !cell.text) {
                                cell.text = messages.zoning.zoneDeleted;
                            }

                            return cell;
                        });
                    });

                zoningTable.body = [header].concat(body);
                zoningTableContainer.table = zoningTable;
                //add custom layout for the table

                zoningTableContainer.layout = {
                    hLineWidth: function() {
                        return 1;
                    },
                    vLineWidth: function() {
                        return 1;
                    },
                    hLineColor: function() {
                        return '#b7b7b7';
                    },
                    vLineColor: function() {
                        return '#b7b7b7';
                    }
                };

                partial = zoningTableContainer;
            } else {
                partial = {
                    text: ''
                };
            }
            return partial;
        }

        /**
         * function to create color palette image from array of colors and array of color values
         * @param  colors is an array containing all colors to be shown in color palette.
         * @param  colorValues is array of labels to be shown below color palette
         * @return table according to pdfmake format.
         */
        function getPaletteImage(colors, colorValues) {
            var partial;
            if (colors.length && colorValues.length) {
                var table = {};
                table.body = [];
                table.widths = '*';
                table.body.push(getColorRow(colors));
                table.body.push(getColorValuesRow(colorValues));
                partial = {
                    margin: [0, 5, 0, 0],
                    table: table,
                    layout: 'noBorders'
                };
            } else {
                partial = {
                    text: ''
                };
            }
            return partial;
        }

        /**
         * function to create a table row from given colors collection
         * @param set of colors (hex values)
         * @return row according to pdfmake format
         */
        function getColorRow(colors) {
            var row = [];
            colors.forEach(function(color) {
                var column = {};
                column.text = '';
                column.colSpan = 2;
                column.fillColor = color;
                column.margin = [0, 8, 0, 8];
                row.push(column);
                //empty column added because of previous column span over 2 columns.
                row.push({});
            });
            return row;
        }

        /**
         * function to add color labels to color palette in floor map.
         * @param  collection of labels(numbers)
         * @return table row according to pdfmake template
         */
        function getColorValuesRow(colorValues) {
            var row = [];
            row.push({
                text: '',

            });
            colorValues.forEach(function(colorValue) {
                var column = {};
                column.text = colorValue.toString();
                column.colSpan = 2;
                column.alignment = 'center';
                column.fontSize = 8;
                row.push(column);
                row.push({});
            });
            row.push({
                text: '',
            });
            return row;
        }
    });
